import { render, staticRenderFns } from "./businessLayout.vue?vue&type=template&id=35e0cf44&scoped=true"
import script from "./businessLayout.vue?vue&type=script&lang=js"
export * from "./businessLayout.vue?vue&type=script&lang=js"
import style0 from "./businessLayout.vue?vue&type=style&index=0&id=35e0cf44&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35e0cf44",
  null
  
)

export default component.exports